export default __webpack_public_path__ + "static/media/logomark-full_color.cfb50d35.svg";